import * as React from "react";
import * as ReactRedux from "react-redux";

import { selectors, actions } from "../reducers/lab_http";
import { selectors as labSelectors, actions as labActions } from "../reducers/lab";

import TextField from "material-ui/TextField";
import CircularProgress from "material-ui/CircularProgress";
const SplitPane = require("react-split-pane");
import * as Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";

import Editor from "./Editor";
import HttpHeaders from "./HttpHeaders";
import HttpVerbButton from "./HttpVerbButton";

import CopyAsCurl from "./CopyAsCurl";
import CopyCurlIcon from "./Example/CopyCurlIcon";
import ResetIcon from "material-ui/svg-icons/navigation/refresh";
import { LabExampleHttp } from "../reducers/lab";

interface RequestProps {
	allowsBody: boolean;
	requestBody: string;
	requestTab: string;
	httpMethod: string;
	requestUrl: string;
	headers: HttpHeadersDict;

	onChangeRequestBody(requestBody: string): void;

	onChangeRequestTab(tabId: string): void;

	onResetRequest(): void;
}

class Request extends React.Component<RequestProps, any> {
	constructor(props) {
		super(props);
	}

	iconStyles = { height: "42px", width: "42px", margin: "auto" };

	state = {
		didReset: false,
	};

	timeout = null;

	onResetRequest() {
		clearTimeout(this.timeout);
		this.setState({ didReset: true });
		this.timeout = setTimeout(() => this.setState({ didReset: false }), 3000);

		this.props.onResetRequest();
	}

	render() {
		const {
			allowsBody,
			requestBody,
			requestTab,
			httpMethod,
			requestUrl,
			onChangeRequestBody,
			onChangeRequestTab,
			headers,
		} = this.props;

		const { didReset } = this.state;

		return (
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					width: "100%",
					height: "100%",
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "space-between",
						paddingLeft: "1rem",
						height: 45,
						color: "white",
					}}
				>
					<div
						style={{
							display: "flex",
							alignItems: "center",
						}}
					>
						{allowsBody && (
							<span
								style={{
									fontWeight: requestTab === "body" ? 700 : 300,
									cursor: "pointer",
									marginRight: "0.5rem",
									paddingBottom: 3,
									borderBottom: requestTab === "body" ? "2px solid #66D9EF" : "",
								}}
								onClick={onChangeRequestTab.bind(this, "body")}
							>
								Body
							</span>
						)}

						<span
							style={{
								fontWeight: requestTab === "headers" ? 700 : 300,
								cursor: "pointer",
								marginRight: "0.5rem",
								paddingBottom: 3,
								borderBottom: requestTab === "headers" ? "2px solid #66D9EF" : "",
							}}
							onClick={onChangeRequestTab.bind(this, "headers")}
						>
							Headers
						</span>
					</div>

					<div
						style={{
							display: "flex",
							flexDirection: "row",
							alignSelf: "center",
						}}
					>
						<CopyAsCurl
							method={httpMethod}
							url={requestUrl}
							body={requestBody}
							headers={headers}
							icon={
								<CopyCurlIcon
									color="white"
									hoverColor="#66D9EF"
									style={{
										cursor: "pointer",
									}}
								/>
							}
						/>

						<Tooltip
							placement="bottomRight"
							overlay={didReset ? "Reset Complete" : "Reset Request"}
						>
							<ResetIcon
								color="white"
								hoverColor="#66D9EF"
								style={{
									cursor: "pointer",
									margin: "auto 1rem auto 0.5rem",
								}}
								onClick={this.onResetRequest.bind(this)}
							/>
						</Tooltip>
					</div>
				</div>

				{requestTab === "body" && (
					<div style={{ display: "flex", flex: 1 }}>
						<Editor
							value={requestBody}
							isReadOnly={false}
							onChangeValue={onChangeRequestBody.bind(this)}
							style={{ marginTop: "0.5rem", height: "" }}
							language="json"
						/>
					</div>
				)}

				{requestTab === "headers" && (
					<HttpHeaders
						headers={headers}
						shouldDisplayHeading={false}
						style={{ flex: 1 }}
						preStyle={{
							backgroundColor: "transparent",
							paddingLeft: "1rem",
							paddingRight: "1rem",
							paddingTop: "0.5rem",
						}}
					/>
				)}
			</div>
		);
	}
}

interface ResponseProps {
	responseStatusCode: number;
	responseStatusText: string;
	responseBody: string;
	responseDuration: number;
	responseHeaders: {};
	responseTab: string;

	onChangeResponseTab(tabId: string): void;
}

class Response extends React.Component<ResponseProps, any> {
	renderResponseBody() {
		return (
			<Editor
				value={this.props.responseBody}
				onChangeValue={() => {
					return;
				}}
				isReadOnly={true}
				style={{ marginTop: "0.5rem", height: "" }}
				language="json"
			/>
		);
	}

	renderResponseHeaders() {
		return (
			<HttpHeaders
				headers={this.props.responseHeaders}
				shouldDisplayHeading={false}
				style={{ flex: 1 }}
				preStyle={{
					backgroundColor: "transparent",
					paddingLeft: "1rem",
					paddingRight: "1rem",
					paddingTop: "0.5rem",
				}}
			/>
		);
	}

	render() {
		const {
			responseStatusCode,
			responseStatusText,
			responseDuration,
			responseTab,
			onChangeResponseTab,
		} = this.props;

		return (
			<div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }}>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						paddingLeft: "1rem",
						marginTop: "0.5rem",
						height: 45,
						color: "grey",
					}}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							color: "white",
						}}
					>
						<span
							style={{
								fontWeight: responseTab === "body" ? 700 : 300,
								cursor: "pointer",
								marginRight: "0.5rem",
								paddingBottom: 3,
								borderBottom: responseTab === "body" ? "2px solid #66D9EF" : "",
							}}
							onClick={onChangeResponseTab.bind(this, "body")}
						>
							Body
						</span>

						<span
							style={{
								fontWeight: responseTab === "headers" ? 700 : 300,
								cursor: "pointer",
								marginRight: "0.5rem",
								paddingBottom: 3,
								borderBottom: responseTab === "headers" ? "2px solid #66D9EF" : "",
							}}
							onClick={onChangeResponseTab.bind(this, "headers")}
						>
							Headers
						</span>
					</div>

					<div style={{ display: "flex", alignItems: "center", marginRight: "1rem" }}>
						<span style={{ color: "white", marginRight: "0.5rem" }}>
							Time: <span style={{ color: "#66D9EF" }}>{responseDuration}</span> ms
						</span>
						<span style={{ color: "white" }}>
							Status:{" "}
							<span style={{ color: "#66D9EF" }}>
								{responseStatusCode} {responseStatusText}
							</span>
						</span>
					</div>
				</div>

				<div style={{ flex: 1, display: "flex" }}>
					{responseTab === "body" && this.renderResponseBody()}
					{responseTab === "headers" && this.renderResponseHeaders()}
				</div>
			</div>
		);
	}
}

interface LabContentHttpProps {
	example: LabExampleHttp;
	isFullscreen: boolean;

	attemptToPerformRequest();

	splitSize: string | number;
	requestTab: string;
	responseTab: string;

	changeExampleData(exampleData: any);

	changeSplitSize(splitSize: string | number);
	changeRequestTab(tabId: string);
	changeResponseTab(tabId: string);

	// todo: move into own reducer
	requestBodyIsAllowed: boolean;
	resetLabRequest();
}

const LabContentHttp = (props: LabContentHttpProps) => (
	<div
		style={{
			flex: 1,
			display: "flex",
			flexDirection: "column",
		}}
	>
		{/* url bar */}
		<div
			style={{
				display: "flex",
				margin: "0.5rem 1rem",
			}}
		>
			<TextField
				name="header"
				value={props.example.data.request.url}
				onChange={(e, value) =>
					props.changeExampleData({
						...props.example.data,
						request: {
							...props.example.data.request,
							url: value,
						},
					})
				}
				style={{
					flex: 1,
				}}
				inputStyle={{
					color: "white",
				}}
			/>

			<div style={{ display: "flex", alignItems: "center", marginLeft: "1rem" }}>
				<HttpVerbButton
					verb={props.example.data.request.method}
					onClick={props.attemptToPerformRequest}
				/>
			</div>
		</div>

		<div
			style={{
				flex: 1,
				position: "relative",
			}}
		>
			<SplitPane
				split={props.isFullscreen ? "vertical" : "horizontal"}
				size={props.splitSize}
				onDragFinished={props.changeSplitSize}
				paneStyle={{
					display: "flex",
				}}
				pane2Style={{
					paddingRight: "15px",
				}}
			>
				<Request
					allowsBody={props.requestBodyIsAllowed}
					requestBody={props.example.data.request.body}
					requestTab={props.requestTab}
					requestUrl={props.example.data.request.url}
					httpMethod={props.example.data.request.method}
					headers={props.example.data.request.headers}
					onResetRequest={props.resetLabRequest.bind(this)}
					onChangeRequestBody={requestBody =>
						props.changeExampleData({
							...props.example.data,
							request: {
								...props.example.data.request,
								body: requestBody,
							},
						})
					}
					onChangeRequestTab={props.changeRequestTab.bind(this)}
				/>

				<div
					style={{
						flex: 1,
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						backgroundColor: "#445a64",
					}}
				>
					{props.example.data.request.status === "" && (
						<p style={{ color: "white", margin: 0, padding: "1rem" }}>
							Press "{props.example.data.request.method}" to see a response.
						</p>
					)}
					{props.example.data.request.status === "pending" && (
						<CircularProgress color="#66D9EF" size={60} thickness={3} />
					)}
					{props.example.data.request.status === "success" && (
						<Response
							responseStatusCode={props.example.data.response.statusCode}
							responseStatusText={props.example.data.response.statusText}
							responseBody={props.example.data.response.body}
							responseDuration={props.example.data.response.duration}
							responseHeaders={props.example.data.response.headers}
							responseTab={props.responseTab}
							onChangeResponseTab={props.changeResponseTab.bind(this)}
						/>
					)}
					{props.example.data.request.status === "failure" && (
						<p style={{ color: "#f92672" }}>An error occurred while performing the request.</p>
					)}
				</div>
			</SplitPane>
		</div>
	</div>
);

const mapStateToProps = state => ({
	splitSize: labSelectors.selectSplitSize(state),
	requestTab: selectors.selectRequestTab(state),
	responseTab: selectors.selectResponseTab(state),
});

const mapDispatchToProps = {
	changeSplitSize: labActions.changeSplitSize,
	changeRequestTab: actions.changeRequestTab,
	changeResponseTab: actions.changeResponseTab,
	changeExampleData: labActions.changeExampleData,
};

const LabContentHttpContainer = ReactRedux.connect(
	mapStateToProps,
	mapDispatchToProps
)(LabContentHttp);

export default LabContentHttpContainer;



// WEBPACK FOOTER //
// ./src/components/LabContentHttp.tsx